import { PkBottomPanel, PkButton } from '@uefadigital/panenka-react';
import { memo, useEffect, useRef, useState } from 'react';

import { useTranslateFn } from '@shared/Translate';
import GoogleTagManagerHelper from '@tracking/gtm-helper';

const AutoLogoutPanel = () => {
  const [showPanel, setShowPanel] = useState(false);
  const panelRef = useRef<HTMLPkBottomPanelElement>(null);
  const t = useTranslateFn();
  const IDP_LOGGED_KEY = 'idp.auth.state';

  useEffect(() => {
    if (!localStorage.getItem(IDP_LOGGED_KEY)) return;

    GoogleTagManagerHelper.event(
      'Click',
      'Dialog - Loaded',
      'relogin',
      { section_reference: 'relogin' },
      'panel_dialog_loaded',
    );
    setShowPanel(true);
    localStorage.removeItem(IDP_LOGGED_KEY);
  }, []);

  const handleClose = () => {
    GoogleTagManagerHelper.event(
      'Click',
      'Dialog - Skip',
      'relogin',
      { section_reference: 'relogin' },
      'panel_dialog_skip',
    );
    setShowPanel(false);
  };

  const handleNotNow = () => {
    GoogleTagManagerHelper.event(
      'Click',
      'Dialog - Secondary action',
      'relogin',
      { section_reference: 'relogin' },
      'panel_dialog_secondary_action',
    );
    setShowPanel(false);
  };

  const handleLogin = () => {
    GoogleTagManagerHelper.event(
      'Click',
      'Dialog - Main action',
      'relogin',
      { section_reference: 'relogin' },
      'panel_dialog_main_action',
    );
    window.showUefaLogin();
    setShowPanel(false);
  };

  if (!showPanel) return null;

  return (
    <PkBottomPanel
      pk-competition='base'
      disableOverlayClose
      pk-theme='light'
      ref={panelRef}
      focusOnOpen
      opened={showPanel}
      onPkClose={handleClose}
      className='pk-bottom-panel'
    >
      <div slot='title' className='pk-font-size--l pk-font--base-bold pk-mb--xs'>
        {t('logged_out_title')}
      </div>
      <div className='pk-font-size--m pk-mb--l'>{t('logged_out_message')}</div>
      <div slot='actions'>
        <PkButton appearance='contained' className='pk-w--100' onPkClick={handleLogin}>
          {t('login')}
        </PkButton>
        <PkButton appearance='text' className='pk-w--100 pk-mt--m' onPkClick={handleNotNow}>
          {t('not_now')}
        </PkButton>
      </div>
    </PkBottomPanel>
  );
};

export default memo(AutoLogoutPanel);
